import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { SiteSimpleImage } from "../../../../commonComponents/inline/siteSimpleImage";
import { SiteArticleSocialShareNew1280 } from "../../../article/componentas/articleSocialShare1280Component/articleSocialShareNew1280";
import { MenuItems } from "./galhadHeaderComponenta";

interface Props {
    menuLogosItems: MenuItems[]
    menuItems: MenuItems[]
    sitename: string

}

interface State {
    hasScrolled: boolean
}
export class GalhadHeaderComponentaContent extends React.Component<Props, State> {
    public static siteScriptName = "GalhadHeaderComponentaContent"
    constructor(props) {
        super(props)
        this.state = {
            hasScrolled: false,
        }
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    private handleScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const shouldHaveScrolledClass = scrollTop > 70; // Adjust threshold as needed

        if (shouldHaveScrolledClass !== this.state.hasScrolled) {
            this.setState({ hasScrolled: shouldHaveScrolledClass });
        }
    }

    render() {
        const { menuLogosItems, menuItems, sitename } = this.props
        return (
            <div className="GalhadHeaderComponenta" style={{ background: this.state.hasScrolled ? "#f9f5f0" : "transparent", transition: "background 0.1s" }}>
                <div className="galhadBgArea" style={{ background: this.state.hasScrolled ? "#fafafa" : "transparent", transition: "background 0.1s" }}>
                    <div className="borderLine"></div>
                </div>
                <div className="sideLogoLinks">
                    {_.map(menuLogosItems, (item, index) => {
                        return (
                            <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} className="sideLink" key={index}>
                                {item.url !== "" && <SiteSimpleImage src={item.url} maxHeight={42} title={item.title} />}
                            </HyperLinkBuilder>

                        )
                    })}
                </div>
                <div className="navLinks">
                    {_.map(menuItems, (item, index) => {
                        return (
                            <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} className="sideLink" key={index}>
                                {item.title}
                            </HyperLinkBuilder>

                        )
                    })}
                </div>


                <SiteArticleSocialShareNew1280
                    categorySubChannel={""}
                    author={""}
                    articleId={""}
                    isBottomButtons={false}
                    showComments={false}
                    isSpotim={false}
                    lang={sitename === "ynetnews" ? "en" : "he"}
                   
                />

            </div>
        )

    }
}